import { createRouter, createWebHistory } from 'vue-router';
// import { createRouter, createWebHistory } from '@ionic/vue-router';
import { store } from '../store/index';

window.popStateDetected = false;
window.addEventListener('popstate', () => {
    window.popStateDetected = true
});

const ifAuthenticated = (to, from, next) => {
    store.dispatch('auth/getToken').then(() => {
        if (store.getters['auth/isAuthenticated']) {
            const IsBrowserBackButton = window.popStateDetected;
            window.popStateDetected = false;
            if (IsBrowserBackButton) {
                next(false);
                return;
            }

            next();
            return;
        } else {
            return next({
                name: 'Login',
                query: { redirect: to.fullPath },
            });
        }
    });
};

const ifNotAuthenticated = (to, from, next) => {
    store.dispatch('auth/getToken').then(() => {
        if (store.getters["auth/isAuthenticated"]) {
            next({ name: "Home" });
            return;
        } else {
            return next();
        }
    });
};

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/LoginPage.vue'),
        beforeEnter: ifNotAuthenticated,
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/HomePage.vue'),
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/game/:gameid/period/:period',
        name: 'Game',
        props: (route) => ({ gameid: Number(route.params.gameid), period: Number(route.params.period) }),
        component: () => import('@/views/MatchPage.vue'),
        beforeEnter: ifAuthenticated,
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// Each build renames the page files, and the service worker drops the old
// ones as soon as a new version is deployed. A page loaded before that still
// asks for the old names, so moving to another page fails silently (stuck on
// Login after a successful login). Load the target page fresh instead, at
// most once every 10 seconds so a broken deploy can't reload in a loop.
const PAGE_RELOAD_KEY = 'page_file_reload_at';

router.onError((error, to) => {
    const message = (error && error.message) || '';
    const isMissingPageFile = (error && error.name === 'ChunkLoadError') || /Loading (CSS )?chunk|dynamically imported module/i.test(message);

    if (!isMissingPageFile || !to) {
        return;
    }

    try {
        const lastReload = Number(sessionStorage.getItem(PAGE_RELOAD_KEY)) || 0;
        if (Date.now() - lastReload < 10000) {
            return;
        }
        sessionStorage.setItem(PAGE_RELOAD_KEY, String(Date.now()));
    } catch (e) {
        // Storage unavailable: still reload once, it is the only way forward.
    }

    window.location.assign(to.fullPath);
});

export default router
